module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Bestellijst"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [(_vm.orderList === null) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner"
  })]) : _c('div', [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n           Bestellijst: " + _vm._s(_vm.orderList.name) + "\n           "), _c('order-list-status-badge', {
    ref: "orderListStatus",
    staticClass: "ml-2",
    attrs: {
      "orderList": _vm.orderList
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Producten")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    ref: "table",
    staticClass: "table table-borderless table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Product")]), _vm._v(" "), _c('th', [_vm._v("Besteld")]), _vm._v(" "), _c('th', [_vm._v("Geleverd")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderList.lines), function(line) {
    return _c('tr', {
      key: line.id
    }, [_c('td', [(line.product.image_urls) ? _c('img', {
      staticClass: "img-avatar img-avatar48",
      attrs: {
        "src": line.product.image_urls[0],
        "alt": ""
      }
    }) : _c('i', {
      staticClass: "si si-picture  fa-2x"
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.product.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.ordered_quantity))]), _vm._v(" "), _c('td', [_c('p', [_vm._v(_vm._s(line.delivered_quantity))])])])
  }), 0)])])]), _vm._v(" "), ((_vm.status === 'ordered' || _vm.status === 'delivered') && _vm.user.role === 'admin') ? _c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.updateStockQuantity()
      }
    }
  }, [_vm._v("\n         Voorraad bijboeken "), _c('i', {
    staticClass: "fa fa-check"
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79014e0a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/order-lists/OrderedOrderListModal.vue
// module id = 735
// module chunks = 1